import { usePWAInstall } from "@/hooks/usePWAInstall";
import { useIsMobile } from "@/hooks/use-mobile";
import { Button } from "@/components/ui/button";
import { X, Download } from "lucide-react";

export default function InstallPrompt() {
  const { canInstall, eligible, isIOS, showInstallPrompt, dismissInstall } = usePWAInstall();
  const isMobile = useIsMobile();

  if (!isMobile || !canInstall || !eligible || isIOS) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-4 pb-[calc(1rem+env(safe-area-inset-bottom))] animate-in slide-in-from-bottom duration-300">
      <div className="mx-auto max-w-md rounded-2xl border border-border bg-card p-4 shadow-xl">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/10">
            <Download className="h-5 w-5 text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-foreground text-sm">Get the ACEX App</p>
            <p className="text-xs text-muted-foreground mt-0.5">
              Install for faster access, offline support &amp; a native experience.
            </p>
          </div>
          <button
            onClick={dismissInstall}
            className="shrink-0 rounded-full p-1 text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Dismiss"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="mt-3 flex gap-2">
          <Button size="sm" className="flex-1" onClick={showInstallPrompt}>
            Install
          </Button>
          <Button size="sm" variant="ghost" className="flex-1" onClick={dismissInstall}>
            Not now
          </Button>
        </div>
      </div>
    </div>
  );
}
